import PropTypes from 'prop-types';
import React from 'react';
import {Select} from 'antd';
import {connect} from 'react-redux';

const DictSelect = ({value, onChange, type_value, dict_types, placeholder, ...props}) => {
    const handleChange = (val) => {
        onChange && onChange(val)
    };

    let options = [];
    const dict_type = dict_types.find(_ => _.value === type_value);
    if (dict_type) {
        options = dict_type.sys_dicts.sort((a, b) => {
            return a.order_index - b.order_index
        }).map(dict => {
            return {
                label: dict.key,
                value: dict.value,
            }
        })
    }

    return (
        <Select
            value={value !== null && value !== undefined ? value.toString() : undefined}
            onChange={handleChange}
            options={options}
            placeholder={placeholder}
            {...props}
        />
    );
};

DictSelect.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    type_value: PropTypes.string,
    placeholder: PropTypes.string,
};

const mapStateToProps = state => ({
    dict_types: state.account.dict_types
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DictSelect);
